// modifer: styles/jss/nextjs-material-kit-pro/pages/aboutUsStyle.js
import { page, main, section, container } from 'styles/jss/original/base';

const styles = {
  page,
  main,
  section,
  container
};

export default styles;
